import { gql } from '@apollo/client'
import { SIMPLE_PRODUCT_FRAGMENT } from '../fragments/SimpleProductFragment'

export const GET_PRODUCTS = gql`
  query GetProducts($input: ProductsInput) {
    products(input: $input) {
      results {
        ...SimpleProduct
      }
      count
      hasMore
    }
  }
  ${SIMPLE_PRODUCT_FRAGMENT}
`
